// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"a8a2a4f611782cf30fa3","691":"a9649da3bb12bf1d033a"}[chunkId] + ".js";
};